import {
	RETIREMENT_ANCHOR_COPY,
	RETIREMENT_ANCHOR_ICONS,
} from "web_myplann/Inspiration/Retirement/constants";
import type { RetirementAnchor } from "web_myplann/Inspiration/Retirement/Types/RetirementTypes";
import type { InspirationAnchor } from "web_myplann/Inspiration/Types/InspirationTypes";

export const mapRetirementAnchor = (
	anchor: RetirementAnchor,
): InspirationAnchor => ({
	key: anchor.key,
	icon: RETIREMENT_ANCHOR_ICONS[anchor.key],
	label: RETIREMENT_ANCHOR_COPY[anchor.key],
	amount: anchor.amount,
});
